import { render } from "./Basis.vue?vue&type=template&id=218a8fa2&scoped=true"
import script from "./Basis.vue?vue&type=script&lang=js"
export * from "./Basis.vue?vue&type=script&lang=js"

import "./Basis.vue?vue&type=style&index=0&id=218a8fa2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218a8fa2"]])

export default __exports__